
export const CREATE_EVENT = 'CREATE_EVENT';
export const UPDATE_EVENT ='UPDATE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT'
export const FETCH_EVENTS = 'FETCH_EVENTS'
export const GET_EVENT_COMMENT ='GET_EVENT_COMMENT'